import { InlineLocationPicker, InlineLocationPickerProps } from 'components/InlineLocationPicker/InlineLocationPicker'
import Styles from './FilePathField.module.scss'

import { FilePathFieldProps } from './Types'
import { useState } from 'react'
import cx from 'classnames'

const LocationPicker = ({ variant = 'secondary', fullWidth = false, ...props }: InlineLocationPickerProps) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div className={cx(Styles.locationPicker, { [Styles.fullWidth]: fullWidth })}>
      <InlineLocationPicker
        {...props}
        variant={variant}
        fullWidth={fullWidth}
        withChevron={isOpen ? 'up' : 'down'}
        dropdownTriggerProps={{ restoreFocus: false, onOpenChange: setIsOpen }}
      />
    </div>
  )
}

const Root = ({ children }: FilePathFieldProps) => {
  return <div className={Styles.filePathField}>{children}</div>
}

export const FilePathField = {
  Root,
  LocationPicker,
}
